import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { HelperService } from 'src/sb-tools/typescript/services/helper.service';
import { AttachmentType } from 'src/sb-tools/typescript/enums/attachment-type.enum';
import { SmilesService } from 'src/sb-tools/typescript/services/smiles.service';
import { QuillHelperService } from 'src/sb-tools/typescript/services/quill/quill-helper.service';
import Quill from 'quill';
import { AttachmentBase } from '@sb-tools/typescript/models/attachment-base.model';
import { ReplyTemplateService } from '../../../../../sb-modules/Frontend-Reply-Templates-Module/core/reply-template.service';
import { QuillReplyTemplatesComponent } from '../../../../../sb-modules/Frontend-Reply-Templates-Module/quill-reply-templates/quill-reply-templates.component';
import { SbQuillMentionComponent } from '../../../../shared/components/sb-quill-mention/sb-quill-mention.component';
import { QuillEditorComponent } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { QuillEmojiPickerComponent } from '../../../../../sb-tools/typescript/components/quill-emoji-picker/quill-emoji-picker.component';
import { InlineSVGComponent } from '../../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { FileViewComponent } from '../../../../../sb-modules/Frontend-Document-Viewer-Module/components/file-view/file-view.component';
import { FilePreviewComponent } from '../../../../../sb-modules/Frontend-Document-Viewer-Module/components/file-preview/file-preview.component';
import { GiphyPickerComponent } from '../../../../../sb-modules/Frontend-GIF-Module/giphy-picker/giphy-picker.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { IsInvalidMessagePipe } from '../../../../../sb-tools/typescript/pipes/ticket/is-invalid-message.pipe';
import { FilterContentAttachmentsPipe } from '../../../../shared/pipes/filter-content-attachments.pipe';

@Component({
    selector: 'app-edit-reply-social-media',
    templateUrl: './edit-reply-social-media.component.html',
    styleUrls: ['./edit-reply-social-media.component.scss'],
    imports: [
        QuillReplyTemplatesComponent,
        SbQuillMentionComponent,
        QuillEditorComponent,
        FormsModule,
        QuillEmojiPickerComponent,
        InlineSVGComponent,
        FileViewComponent,
        FilePreviewComponent,
        GiphyPickerComponent,
        TooltipModule,
        TranslateModule,
        IsInvalidMessagePipe,
        FilterContentAttachmentsPipe,
    ],
})
export class EditReplySocialMediaComponent implements OnInit {
    @Input() parent;
    @Input() parentReply?;
    @Input() reply;
    @Input() replyModel;
    @Input() ticket;

    attachmentTypeEnum = AttachmentType;
    quillConfig = {
        toolbar: false,
    };
    quillEditor: Quill;
    usersToMention;
    editedReplyText = '';

    constructor(
        public commonDataService: CommonDataService,
        public replyTemplateService: ReplyTemplateService,
        private smilesService: SmilesService,
        private quillHelperService: QuillHelperService,
    ) {}

    ngOnInit() {
        this.editedReplyText = this.reply.message.text;
    }

    addGifAttachment(gif: AttachmentBase) {
        this.reply.attachments.push(gif);
    }

    cancelEditReply(reply) {
        reply.editingReply = !reply.editingReply;
        reply.message = structuredClone(reply.oldMessage);
        reply.attachments = structuredClone(reply.oldAttachments);
    }

    deleteAttachment(attachment) {
        const index = this.reply.attachments.indexOf(attachment);
        this.reply.attachments.splice(index, 1);
    }

    onEditorCreated(quill) {
        this.quillEditor = quill;

        if (this.quillHelperService.editedReplyId === this.reply.id) {
            this.quillEditor.setSelection(this.editedReplyText.length);
            quill.focus();
        }
    }

    onReplyChanged(data) {
        this.reply.message.text = HelperService.strip(this.smilesService.replaceImagesToCodes(data.html), false);
        this.reply.message.html = data.html;
    }
}
